import { InsuranceProvider } from './components/SearchHeader/constants';

/** Provides enough time for a user action to fully complete, eg typing into a field */
export const SLOW_USER_INTERACTION_DEBOUNCE = 300;

/** Provides about enough time for a user to finish typing a single word. Attempts to strike a
 * balance between being responsive and jumpy. */
export const FAST_USER_INTERACTION_DEBOUNCE = 150;

export const SLOWEST_USER_INTERACTION_DEBOUNCE = 500;

/** Show the new filter bar even if not enabled by an experiment */

/** Time out for slide out menus */
export const SLIDE_OUT_TIMEOUT = 300;

// Mouse click event types
export enum MouseButton {
  LEFT = 0,
  MIDDLE = 1,
  RIGHT = 2,
}

export enum Source {
  Articles = 'articles',
  Practice = 'practice',
  Practitioner = 'practitioner',
  ProfileLightbox = 'profile-lightbox',
  Corporate = 'corporate',
}

export const COVAX_ELIGIBILITY_COOKIE = 'covaxEligibilityChecked';

export const VACCINE_TYPE_PROMPT_COOKIE = 'vaccineTypePrompted';

export const MCT_PHI_NOTIFICATION_SEEN = 'mctPhiNotificationSeen';

export const PHI_PARTNER_NAME = InsuranceProvider.HBF;

export const TELEHEALTH_SERVICES_LANDING_URL =
  'https://services.healthengine.com.au/telehealth-gp-options';
